// 지난주 인사이트. 지난주(월~일) 측정값으로 월요일에 만든 것이라 '지난주' 로 부른다(2026-09-29 사용자). AI 가 쓴 문장과
// 사용자 알림 문구를 함께 보여 준다 — 보냈든 아니든 문구가 있으면 보여 준다(2026-09-29)., 사용자에게 실제로 나간 알림을 함께 보여 준다.
//
// ⚠️ "사용자에게 보낸 알림" 은 빼지 말 것. 대상자가 전화했을 때 담당자가 무엇이
//    갔는지 알아야 한다 — 앱에는 받은 푸시를 다시 볼 방법이 없다(스펙 D6).
// ⚠️ 문장 속 수치는 서버가 이미 치환한 값이다. 화면에서 다시 계산하지 않는다.

import React from 'react';
import { Sparkles, Bell } from 'lucide-react';

const SEVERITY_TONE = { good: 'normal', info: 'info', caution: 'caution', attention: 'danger' };

const formatRange = (week) => `${week.weekStart.slice(5).replace('-', '.')} ~ ${week.weekEnd.slice(5).replace('-', '.')}`;

// 가장 최근 주만 보여 준다. 주 넘기기·근거 수치 줄·발송 상태 줄은 2026-09-23 사용자 요청으로 뺐고,
// 알림을 보내지 않은 주는 알림 행 자체를 그리지 않는다.
const WeeklyInsightSection = ({ weeks = [], loading = false, error = null }) => {
    const week = weeks[0];

    return (
        <div className="sds-list detail-page__insights">
            <div className="sds-list__title">
                지난주 인사이트
                <span className="detail-page__insights-badge">
                    <Sparkles size={12} aria-hidden="true" /> AI 가 정리했어요
                </span>
            </div>

            {error && <p className="sds-list__empty">인사이트를 불러오지 못했습니다.</p>}
            {!error && loading && <p className="sds-list__empty">불러오는 중…</p>}
            {!error && !loading && weeks.length === 0 && (
                <p className="sds-list__empty">아직 만들어진 인사이트가 없습니다. 매주 월요일에 지난주 측정값으로 만듭니다.</p>
            )}

            {week && (
                <>
                    <div className="detail-page__insights-range">{formatRange(week)}</div>

                    {week.summary && <p className="detail-page__insights-summary">{week.summary}</p>}

                    {week.findings.length === 0
                        ? <p className="sds-list__empty">이 주에는 눈에 띄는 변화가 없었습니다.</p>
                        : week.findings.map((finding, i) => (
                            <div className="sds-list__row" key={`${week.id}-${i}`}>
                                <span className={`sds-list__icon sds-list__icon--sm sds-list__icon--${SEVERITY_TONE[finding.severity] || 'none'}`} aria-hidden="true" />
                                <div className="sds-list__body">{finding.text}</div>
                            </div>
                        ))}

                    {/* 알림 문구가 있으면 무조건 보여 준다(2026-09-29 사용자). 보냈는지 여부는 제목 한 단어로만 가른다. */}
                    {(week.push.title || week.push.body) && (
                        <div className="sds-list__row detail-page__insights-push">
                            <span className="sds-list__icon sds-list__icon--sm sds-list__icon--info" aria-hidden="true">
                                <Bell size={14} aria-hidden="true" />
                            </span>
                            <div className="sds-list__body">
                                <b>{week.push.status === 'published' ? '사용자에게 보낸 알림' : '사용자 알림 문구'}</b>
                                {week.push.title && <div className="detail-page__insights-push-title">{week.push.title}</div>}
                                {week.push.body && <div className="detail-page__insights-push-body">{week.push.body}</div>}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default WeeklyInsightSection;
